export enum RouteEnum {
  DownloadTester ='download-tester',
  PerformanceHistory ='performance-history',
  TranslatorApi ='translator-api',
  LanguageDetectorApi = 'language-detector-api',
  WriterApi = 'writer-api',
  RewriterApi = 'rewriter-api',
  ProofreaderApi = 'proofreader-api',
  SemanticEmbedderApi = 'semantic-embedder-api',
  Autocomplete = 'autocomplete',
  SummarizerApi = 'summarizer-api',
  PromptApi = 'prompt-api',
  PerformanceTestRunner = 'performance/perf-test-runner',
  // @start-remove-in-chrome-dev
  ImageMultimodalPromptApi = 'image-multimodal-prompt-api',
  AudioMultimodalPromptApi = 'audio-multimodal-prompt-api',
  TranscriptionAudioMultimodalPromptApi = 'transcription-audio-multimodal-prompt-api',
  MultimodalPromptApi = 'multimodal-prompt-api',
  // @end
  SummarizerBatchPage = 'summarizer-batch-page',
  Home = 'index',

  AvailabilityCreator = 'availability-creator',

  // Studio
  Chat = 'chat',
  WebAiStudio = 'web-ai-studio',
}
